import { Button } from '@mui/material';
import {
  ArrowDownward,
  ArrowUpward,
  ContentCopy,
  Photo,
  DragHandle,
  VerticalAlignBottom,
  VerticalAlignTop,
  FormatAlignCenter,
  DisplaySettings,
} from '@mui/icons-material';

import styles from './BlockSlot.module.css';

enum BlockSlotPanelEventType {
  UP = 0,
  DOWN = 1,
  TOP = 2,
  BOTTOM = 3,
  DUPLICATE = 4,
}

type BlockSlotPanelEvent = (id: string, event: BlockSlotPanelEventType) => void;

const buttonOptions = [
  {
    icon: ArrowUpward,
    event: BlockSlotPanelEventType.UP,
  },
  {
    icon: ArrowDownward,
    event: BlockSlotPanelEventType.DOWN,
  },
  {
    icon: VerticalAlignTop,
    event: BlockSlotPanelEventType.TOP,
  },
  {
    icon: VerticalAlignBottom,
    event: BlockSlotPanelEventType.BOTTOM,
  },
  {
    icon: ContentCopy,
    event: BlockSlotPanelEventType.DUPLICATE,
  },
];

interface ButtonGroupProps {
  handleImageIconClicked?: () => void;
  handlePanelEvent: BlockSlotPanelEvent;
  showOptionsForLines?: boolean;
  showOptionsForAlignment?: boolean;
  showOptionsForDisplaySettings?: boolean;
  handleLinesOptionsClicked?: () => void;
  handleAlignmentOptionsClicked?: () => void;
  handleDisplaySettingsClicked?: () => void;
  dataId: string;
}

function BlockSlotActionsButtonGroup({
  handleImageIconClicked,
  handlePanelEvent,
  showOptionsForLines,
  showOptionsForAlignment,
  showOptionsForDisplaySettings,
  handleLinesOptionsClicked,
  handleAlignmentOptionsClicked,
  handleDisplaySettingsClicked,
  dataId,
}: ButtonGroupProps) {
  return (
    <div className="buttonContainer">
      {showOptionsForLines && (
        <Button
          size="small"
          variant="contained"
          className={styles.slotOptionsButton}
          onClick={handleLinesOptionsClicked}
        >
          <DragHandle fontSize="small" />
        </Button>
      )}

      {showOptionsForAlignment && (
        <Button
          size="small"
          variant="contained"
          className={styles.slotOptionsButton}
          onClick={handleAlignmentOptionsClicked}
        >
          <FormatAlignCenter fontSize="small" />
        </Button>
      )}

      {showOptionsForDisplaySettings && (
        <Button
          size="small"
          variant="contained"
          className={styles.slotOptionsButton}
          onClick={handleDisplaySettingsClicked}
        >
          <DisplaySettings fontSize="small" />
        </Button>
      )}

      {handleImageIconClicked && (
        <Button
          size="small"
          variant="contained"
          className={styles.slotOptionsButton}
          onClick={handleImageIconClicked}
        >
          <Photo fontSize="small" />
        </Button>
      )}

      {buttonOptions.map((option) => (
        <Button
          key={option.event}
          size="small"
          variant="contained"
          className={styles.slotOptionsButton}
          onClick={() => handlePanelEvent(dataId, option.event)}
        >
          <option.icon fontSize="small" />
        </Button>
      ))}
    </div>
  );
}

export default BlockSlotActionsButtonGroup;
